module.exports = true;


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/core-js/library/modules/_library.js
// module id = 18
// module chunks = 0 1